import mediaInfoFactory from 'mediainfo.js';

const TICKS_PER_SECOND = 254016000000n;

export interface AudioInfo {
  fileSize: number;          // bytes
  durationSeconds: number;   // normal seconds (useful for plan limits)
  durationTicks: bigint;     // what Premiere expects
  sampleRate: number;        // Hz
}

export async function getAudioInfo(file: File): Promise<AudioInfo> {
  const mediainfo = await mediaInfoFactory({
    locateFile: () => '/MediaInfoModule.wasm',
  });

  try {
    const result = await mediainfo.analyzeData(
      () => file.size,
      (chunkSize, offset) =>
        file.slice(offset, offset + chunkSize)
          .arrayBuffer()
          .then(buf => new Uint8Array(buf))
    );

    const audioTrack: any = result.media?.track?.find(
      (t: any) => t['@type'] === 'Audio'
    );

    if (!audioTrack) {
      throw new Error('No audio track found');
    }

    const durationSeconds = parseFloat(audioTrack.Duration);
    const sampleRate = parseInt(audioTrack.SamplingRate, 10);

    if (isNaN(durationSeconds) || isNaN(sampleRate)) {
      throw new Error('Could not read duration or sample rate');
    }

    // Convert to Premiere ticks
    const durationTicks = BigInt(Math.round(durationSeconds * Number(TICKS_PER_SECOND)));

    return {
      fileSize: file.size,
      durationSeconds,
      durationTicks,
      sampleRate,
    };
  } finally {
    mediainfo.close();
  }
}